import classes from './CopyTextButton.module.css';
import { classNames } from '@axo/shared/util/dom';
import { Button } from '@blueprintjs/core';
import { ReactNode, useEffect, useState } from 'react';

function copyToClipBoard(textToCopy: string) {
  window.navigator.clipboard.writeText(textToCopy);
}

export function CopyTextButton({
  value,
  children,
}: {
  value: string;
  children: ReactNode;
}) {
  const [action, setAction] = useState(false);
  useEffect(() => {
    if (!action) return;
    const timeout = setTimeout(() => setAction(false), 500);
    return () => clearTimeout(timeout);
  }, [action]);
  return (
    <Button
      rightIcon="duplicate"
      small
      minimal
      className={classNames(classes.base, action && classes.active)}
      onClick={() => {
        copyToClipBoard(value);
        setAction(true);
      }}
    >
      {children}
      <span
        aria-hidden="true"
        className={classNames(classes.overlay, classes.hover)}
      >
        Copy
      </span>
      <span
        aria-hidden="true"
        className={classNames(classes.overlay, classes.action)}
      >
        Copied!
      </span>
    </Button>
  );
}
